export default "__VITE_ASSET__CBi_S59v__"